import React, { Fragment } from 'react';
import classNames from 'classnames';
import DateSelect from 'components/DateSelect';
import Select from 'components/newComponents/Select';
import { periodLength, jobStatusType } from '../reportConstants';
import DropdownMenu from 'components/DropdownMenu';

const Filter = (props) => {
  const { data, actions } = props;
  const { values, companiesList, userNames } = data;
  const { isValidHandler, handleSelect, selectPeriod, selectDate, selectAllUsers, selectUser, handleSubmit } = actions;

  return (
    <form onSubmit={handleSubmit}>
      <div className="new-table">
        <div className="new-table--row no-padding">
          <div className="new-table--row--item select w10">
            {companiesList.length > 0 && (
              <Select
                name="company_id"
                options={companiesList}
                value={values['company_id']}
                onChange={({ value }) => handleSelect('company_id', value)}
              />
            )}
          </div>

          <div className="new-table--row--item select w10">
            <Select name="period_type" options={periodLength} value={values['period_type']} onChange={selectPeriod} />
          </div>

          <div className="new-table--row--item select w20">
            <DateSelect name="from" selected={values['from']} placeholder="From date" className="w45 placeholder-date" onChange={selectDate} />
            <DateSelect name="to" selected={values['to']} placeholder="To date" className="w45 placeholder-date" onChange={selectDate} />
          </div>

          <div className="new-table--row--item select w10">
            <Select
              name="status_type"
              options={jobStatusType}
              value={values['status_type']}
              onChange={({ value }) => handleSelect('status_type', value)}
            />
          </div>

          <DropdownMenu
            name="user_id"
            divClassName="new-table--row--item select w10 d-block"
            button={{
              spanTitle: 'Select agent',
              className: classNames('', { error: isValidHandler('user_id'), default: !isValidHandler('user_id') }),
            }}
            dontHide
            listStyle={{ left: 0, marginTop: 15, width: 250 }}
            menu={
              <Fragment>
                <label style={{ padding: '10px 5px', justifyContent: 'flex-start', fontWeight: 700 }}>
                  <input
                    type="checkbox"
                    checked={values['user_id'].length === userNames.length}
                    style={{ marginRight: 7 }}
                    onChange={() => selectAllUsers(userNames)}
                  />
                  Select All
                </label>
                {userNames.map((item) => (
                  <label style={{ padding: '10px 5px', justifyContent: 'flex-start', fontWeight: 700 }} key={item.value}>
                    <input
                      type="checkbox"
                      checked={values['user_id'].includes(item.value)}
                      style={{ marginRight: 7 }}
                      onChange={() => selectUser(item.value)}
                    />
                    {item.label}
                  </label>
                ))}
              </Fragment>
            }
          />

          <div className="new-table--row no-padding w10">
            <div className="new-table--row--item w10 no-padding justify-content-end">
              <button type="submit" className="confirm px-5 py-3">
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Filter;
